/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FinancialCreateFinancialRequest } from "../models/FinancialCreateFinancialRequest";
import type { FinancialCreateFinancialResponseApiRespoonse } from "../models/FinancialCreateFinancialResponseApiRespoonse";
import type { FinancialDeleteFinancialRequest } from "../models/FinancialDeleteFinancialRequest";
import type { FinancialDeleteFinancialResponseApiRespoonse } from "../models/FinancialDeleteFinancialResponseApiRespoonse";
import type { FinancialEditFinancialRequest } from "../models/FinancialEditFinancialRequest";
import type { FinancialEditFinancialResponseApiRespoonse } from "../models/FinancialEditFinancialResponseApiRespoonse";
import type { FinancialListFinancialRequest } from "../models/FinancialListFinancialRequest";
import type { FinancialListFinancialResponseApiRespoonse } from "../models/FinancialListFinancialResponseApiRespoonse";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class FinancialManagerService {
  /**
   * Get list Financial
   * @param requestBody
   * @returns FinancialListFinancialResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static financial(
    requestBody: FinancialListFinancialRequest
  ): CancelablePromise<FinancialListFinancialResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/financial",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Create Financial
   * @param requestBody
   * @returns FinancialCreateFinancialResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static financialCreate(
    requestBody: FinancialCreateFinancialRequest
  ): CancelablePromise<FinancialCreateFinancialResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/financial/create",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Update Financial
   * @param requestBody
   * @returns FinancialEditFinancialResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static financialEdit(
    requestBody: FinancialEditFinancialRequest
  ): CancelablePromise<FinancialEditFinancialResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/financial/edit",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Delete Financial
   * @param requestBody
   * @returns FinancialDeleteFinancialResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static financialDelete(
    requestBody: FinancialDeleteFinancialRequest
  ): CancelablePromise<FinancialDeleteFinancialResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/financial/delete",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }
}
